// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const {WIZARD_VERTICAL_VIEW_MODE} = require('constants/index');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const SendPinByMailStep1 = require('./sendPinByMailStep1/sendPinByMailStep1');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const {
    CIC_CHANNEL
} = require('constants/index');
var _require2 = require('constants/operationTypes'),
PIN_MAILING_ID = _require2.PIN_MAILING_ID;

class sendPinByMailView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
        this.handleFinish = this.handleFinish.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillReceiveProps(nextProps){
        const hasError = !!nextProps.immCodeOTPData.get('error');
        if(this.state.showModal != hasError){
            this.setState({showModal:hasError});
        }
    }

    handleFinish(){
        this.props.sendPinSuccess(this.props.cardId);
    }

    handleCancel() {
        this.props.history.push(apiURLBuilder.getURL("cardIdUrl", {cardId: this.props.cardId}));
    }

     buildWizard(){
        const {immCards,immProfileFields, immUserData, immSendPinData, setVisibleStep, validateStep ,setWillCancel} = this.props;
        const isFetching =  immUserData.get('isFetching');
        const immSteps = immSendPinData.get('steps');
        const isFetchingSending = immSendPinData.get('isFetching');
        const stepsAmount = immSteps.size;
        const address = PersonalDataHelper.getFormattedAddress(immProfileFields);
        const visibleStep = immSendPinData.get('visibleStep');
        const nextBtnLabel = 'sendPinByMailStep3-confirmBtn';
        const pan = this.props.immCards.get('number').replace(/\s/g,'');
        const beneficiaryName = immCards.get('beneficiaryName');
        const operationParams =  {
          "channel": CIC_CHANNEL,
          "pan": pan,
        }
        const actions = {
            setVisibleStep,
            validateStep,
            finish: this.handleFinish,
            setWillCancel : setWillCancel,
            cancel: this.handleCancel
        };

        let content;

        if (isFetching) {
              content = (<LoadingSection/>);
        } else {
            content = (
                <Wizard
                    actions={actions}
                    fullWidth={false}
                    immSteps={immSteps}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    viewMode={WIZARD_VERTICAL_VIEW_MODE}
                    >
                    <WizardStep
                        position="first"
                        cancelButton
                        isLoading={false}
                        nextBtnModifier="primary">
                        <SendPinByMailStep1
                            address={address}
                            beneficiaryName={beneficiaryName}
                            immCards={immCards}
                        />
                    </WizardStep>
                    <WizardStep
                        addLoadingBehaviour
                        cancelButton
                        immFinalButton={nextBtnLabel}
                        isLoading={isFetchingSending}
                        omitPreviousButton
                        position="last"
                        nextBtnModifier="primary"
                        >
                        <VerifyOtpStep
                            operationType={PIN_MAILING_ID}
                            operationParams={operationParams}
                        />
                    </WizardStep>
                </Wizard>
            );
        }
        return content;
    }

    render() {
        const content = this.buildWizard();

        return (
            <div className="keyscc-view">
                {content}
            </div>
        );
    }
}

sendPinByMailView.propTypes = {
    history: PropTypes.object.isRequired,
    immUserData: PropTypes.object.isRequired,
    immCodeOTPData : PropTypes.object,
    immKeysData : PropTypes.object,
    immProfileFields: PropTypes.object,
    immSendPinData: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    sendPinSuccess: PropTypes.func,
    immCards: PropTypes.object.isRequired,
    cardId: PropTypes.string.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports = withRouter(sendPinByMailView);
